module.exports = __webpack_public_path__ + "static/media/808Knob--shuffle.58a319e6.svg";